import { render, staticRenderFns } from "./ThemeTableSortSkeleton.vue?vue&type=template&id=3b74d21e&scoped=true"
import script from "./ThemeTableSortSkeleton.vue?vue&type=script&lang=js"
export * from "./ThemeTableSortSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ThemeTableSortSkeleton.vue?vue&type=style&index=0&id=3b74d21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74d21e",
  null
  
)

export default component.exports